import cx from 'classnames'
import PropTypes from 'prop-types'

import {GAP_SIZES} from './settings.js'

const ListMobileScroll = ({items, gapSize = GAP_SIZES.m}) => {
  const listClassName = cx('mt-ListMobileScroll', `mt-ListMobileScroll--gap--${gapSize}`)
  return (
    <ul className={listClassName}>
      {items.map((Item, index) => (
        <li className="mt-ListMobileScroll-item" key={index}>
          <Item />
        </li>
      ))}
    </ul>
  )
}

ListMobileScroll.displayName = 'ListMobileScroll'

ListMobileScroll.propTypes = {
  gapSize: PropTypes.oneOf(Object.values(GAP_SIZES)),
  items: PropTypes.func.isRequired
}

export default ListMobileScroll
